import { FocusVersionScheduling, ScheduleAvailType } from '@/redux/slices/slice_types';

export const getScheduleAvailValues = (schedule: FocusVersionScheduling, type: ScheduleAvailType): string[] => {
  if (type === 'territories') {
    return schedule.territory ?? [];
  }

  if (type === 'audio') {
    return schedule.audio_languages ?? [];
  }

  return schedule.timed_text_languages ?? [];
};
